import React from "react";
import RegistrarDashboard from "./RegistrarDashboard";
import RegistrarMasterDashboard from "./RegistrarMasterDashboard";
import { Accordion } from "react-bootstrap";

function RegistrarDashboardTab() {
  return (
    <>
      <Accordion defaultActiveKey={"0"}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>สรุปจดทะเบียนชาวไร่อ้อย</Accordion.Header>
          <Accordion.Body>
            <RegistrarDashboard />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion defaultActiveKey={"1"}>
        <Accordion.Item eventKey="1">
          <Accordion.Header>สรุปจดหัวหน้ากลุ่มชาวไร่อ้อย</Accordion.Header>
          <Accordion.Body>
            <RegistrarMasterDashboard />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default RegistrarDashboardTab;
